// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","size":"125px","ingredient":"G2a02ea G41b766","imageContainer":"G6adc67","loadingSkeleton":"G45d29c","loading-skeleton":"G7f3756"};